<template>
  <div class="userInfoBox">
    <div>
      <van-cell-group>
        <van-field
          required
          v-model="userInfo.Name"
          clearable
          label="姓 名"
          placeholder="请输入姓名"
          v-scrolltop
        />
        <!--<van-field required v-model="userInfo.IDCard" clearable label="身份证" placeholder="请输入身份证" :error-message="idCardMessage" error-message-align="right" @blur="idCardChange" v-scrolltop/>-->
        <van-field
          required
          v-model="userInfo.StudentID"
          clearable
          label="学 号"
          :error-message="studentIDMessage"
          error-message-align="right"
          @blur="studentIDChange"
          placeholder="请输入学号"
          v-scrolltop
        />
        <van-field
          required
          v-model="userInfo.Mobile"
          clearable
          label="手 机"
          :error-message="mobileMessage"
          error-message-align="right"
          @blur="mobileChange"
          placeholder="请输入手机"
          v-scrolltop
        />
        <van-cell
          title="性 别"
          is-link
          :value="userInfo.Sex === 1 ? '男' : '女'"
          @click.native="Sex = !Sex"
        />
        <van-cell
          title="在读学历"
          is-link
          :value="userInfo.Education1"
          @click="EducationClick1 = !EducationClick1"
        ></van-cell>
        <van-cell
          title="当前年级"
          is-link
          :value="userInfo.Education2"
          @click="EducationClick2 = !EducationClick2"
        ></van-cell>
      </van-cell-group>
      <!--<van-cell-group>-->
      <!--<van-field v-model="userInfo.Education" clearable label="学 历" placeholder="请输入学历"/>-->
      <!--<van-field v-model="userInfo.Major" clearable label="专 业" placeholder="请输入专业"/>-->
      <!--<van-field v-model="userInfo.StudentID" clearable label="学 号" placeholder="请输入学号"/>-->
      <!--</van-cell-group>-->
<!--      <van-cell-group class="adr">-->
<!--        <van-cell-->
<!--          required-->
<!--          title="地 址"-->
<!--          is-link-->
<!--          :value="userInfo.FullAddress ? userInfo.FullAddress : '请选择地址'"-->
<!--          to="/userIn/userAddress?isCache=Cache"-->
<!--        />-->
<!--      </van-cell-group>-->
      <van-button
        type="info"
        size="normal"
        :loading="btnLoading"
        loading-text="正在提交..."
        @click="editUserInfo"
        style="background: #48bd4b !important;border-color:#48bd4b">确&nbsp;定</van-button>
    </div>
    <van-popup
      v-model="select"
      position="bottom"
      style="width: 100%; height: 80%"
    >
      <div style="height: 100%; overflow-y: auto">
        <template v-for="(item, index) in RegionList">
          <van-cell @click="region(item, index)">
            <template slot="title">
              <span
                >{{ item.Name }}
                <span v-if="item.ExtendName"
                  >（{{ item.ExtendName }}）</span
                ></span
              >
            </template>
          </van-cell>
        </template>
      </div>
    </van-popup>
    <van-popup v-model="EducationClick1" position="bottom">
      <van-picker
        :columns="Education1"
        show-toolbar
        title="在读学历"
        @cancel="EducationClick1 = !EducationClick1"
        @confirm="onConfirm1"
      />
    </van-popup>
    <van-popup v-model="EducationClick2" position="bottom">
      <van-picker
        :columns="Education2"
        show-toolbar
        title="在读学历"
        @cancel="EducationClick2 = !EducationClick2"
        @confirm="onConfirm2"
      />
    </van-popup>
    <van-action-sheet v-model="Sex" :actions="actions" @select="onSelect" />
  </div>
</template>

<script>
import { setWeixInfo, removeWeixInfo } from "@/utils/auth";
import {getCookie, removeCookie} from "@/utils/cookie";
export default {
  name: "userInfo",
  data() {
    return {
      Education1: [],
      Education2: [],
      EducationClick1: false,
      EducationClick2: false,
      btnLoading: false,
      mobileMessage: "",
      idCardMessage: "",
      studentIDMessage: "",
      Sex: false,
      actions: [
        {
          name: "男",
        },
        {
          name: "女",
        },
      ],
      Education: false,
      addressStr: "",
      index: 0,
      RegionId: "",
      userAddress: [],
      RegionList: [],
      transitionName: "",
      userInfo: {
        StudentID: "",
        FullAddress: "",
        Sex: 1,
      },
      select: false,
    };
  },
  watch: {
    select(val) {
      if (val) {
        this.transitionName = "slide-left";
      } else {
        this.transitionName = "slide-right";
      }
    },
    $route(to, from) {
      if (["/user"].indexOf(from.path) > -1) {
        //自行添加逻辑，list为你不想有缓存的路径
        this.$store.dispatch("setAddress", []); // 清空地址
        this.getUserInfo();
      }
    },
  },
  components: {},
  methods: {
    studentIDChange() {
      if (this.userInfo.StudentID && this.userInfo.StudentID !== "") {
        this.studentIDMessage = "";
      } else {
        this.studentIDMessage = "请输入学号";
      }
    },
    onConfirm1(value) {
      this.userInfo.Education1 = value.Value;
      this.EducationClick1 = false;
    },
    onConfirm2(value) {
      this.userInfo.Education2 = value.Value;
      this.EducationClick2 = false;
    },
    mobileChange() {
      if (!/^1[3456789]\d{9}$/.test(this.userInfo.Mobile))
        this.mobileMessage = "手机号码有误！";
      else this.mobileMessage = "";
    },
    idCardChange() {
      if (!this.userInfo.IDCard) {
        this.idCardMessage = "请填入身份证号";
      } else if (
        !/^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/.test(
          this.userInfo.IDCard
        )
      ) {
        this.idCardMessage = "身份证号有误";
      } else {
        this.idCardMessage = "";
      }
    },
    onSelect(val) {
      this.$set(this.userInfo, "Sex", val.name === "男" ? 1 : 0);
      this.Sex = !this.Sex;
    },
    region(item, index) {
      this.$toast.loading({
        duration: 0,
      });
      this.index++;
      const params = {};
      if (this.index === 1) {
        if (params.ParentId !== "") {
          this.$delete(params, "ParentId");
        }
        this.RegionId = item.Id;
      } else {
        params.ParentId = item.Id;
      }
      if (item.ExtendName !== undefined) {
        this.userAddress.push({
          name: item.Name + "(" + item.ExtendName + ")",
          Id: item.Id,
        });
      } else {
        this.userAddress.push({
          name: item.Name,
          Id: item.Id,
        });
      }
      params.RegionId = this.RegionId;
      this.$post("/BizMemberDormitory/AllList", params).then((res) => {
        if (res.Data) {
          if (res.Data.List.length > 0) {
            this.RegionList = res.Data.List;
          } else {
            this.select = false;
            let str = "";
            this.userAddress.forEach((item) => {
              str += item.name + "-";
            });
            this.userInfo.FullAddress = str.substr(0, str.length - 1);
            this.index = 0;
          }
          this.$toast.loading().clear();
        }
      });
    },
    editUserInfo() {
      if (this.userAddress.length === 1 || (this.userAddress.length && !this.userAddress[this.userAddress.length -1].IsLeaf)) {
        this.$toast("当前地址暂未开通服务，请重新选择！");
        return false;
      }
      this.btnLoading = true;
      const params = this.userInfo;
      params.Education = params.Education1 + "|" + params.Education2;
      params.DormitoryId =
        this.userAddress.length > 0
          ? this.userAddress[this.userAddress.length - 1].Id
          : this.userInfo.DormitoryId; // 判断是否存在地址修改后的数组，如果有则从数组中取，如果没有，则从源数据中返回宿舍ID
      this.$post("/BizMemberMember/Edit", params).then((res) => {
        this.btnLoading = false;
        if (res.Status === 1) {
          removeWeixInfo();
          setWeixInfo(JSON.stringify(res.Data));
          removeCookie('userAddressCache')
          this.$toast({
            duration: 1500,
            message: res.Message,
          });
        }
      });
    },
    getUserInfo() {
      this.$post("/BizMemberMember/DetailsByKey").then((res) => {
        if (res) {
          if (res.Data.FullAddress) {
            res.Data.FullAddress =
              res.Data.RegionName + "-" + res.Data.FullAddress;
          }
          this.userInfo = res.Data;
          this.fetchAddress()
          this.userInfo.Education1 = this.userInfo.Education.split("|")[0];
          this.userInfo.Education2 = this.userInfo.Education.split("|")[1];
        }
      });
    },
    fetchAddress() {
      if (this.$store.getters.addressList.length > 0) {
        this.userAddress = this.$store.getters.addressList;
      }
      const userAddressCache = getCookie('userAddressCache')
      if (userAddressCache) {
        this.userAddress = JSON.parse(userAddressCache)
      }
      if (this.userAddress.length) {
        let str = "";
        this.userAddress.forEach((item) => {
          str += item.name + "-";
        });
        this.userInfo.FullAddress = str.substr(0, str.length - 1);
      }

    },
  },
  mounted() {
    this.getUserInfo();
    this.$post("/BizMemberDictionary/AllList", { ParetnName: "学历" }).then(
      (res) => {
        if (res) {
          this.Education1 = res.Data;
          this.Education1.forEach((data) => {
            data.text = data.Name;
          });
        }
      }
    );
    this.$post("/BizMemberDictionary/AllList", { ParetnName: "年级" }).then(
      (res) => {
        if (res) {
          this.Education2 = res.Data;
          this.Education2.forEach((data) => {
            data.text = data.Name;
          });
        }
      }
    );
  },
  activated() {
    this.fetchAddress();
  },
};
</script>

<style scoped lang="less">
.van-cell__value {
  overflow: hidden;
}
.van-cell-group {
  margin-top: 15px;
}
.van-button {
  display: block;
  width: 90%;
  margin: 5% auto;
}
</style>
<style lang="less">
.userInfoBox {
  position: relative;
  .van-field__body {
    input {
      text-align: right;
    }
  }
  .adr {
    .van-cell__title {
      flex: 0.2;
      -webkit-box-flex: 0.2;
      -webkit-flex: 0.2;
    }
  }
}
</style>
